(() => {
  if (customElements.get('celvian-community') || document.documentElement.dataset.cvCommunityLoader) return;
  const source = document.currentScript?.dataset.communitySource;
  if (!source) return;
  let url;
  try { url = new URL(source, document.baseURI); } catch (_) { return; }
  if (url.origin !== location.origin && !(url.protocol === 'https:' && url.hostname === 'cdn.shopify.com')) return;
  document.documentElement.dataset.cvCommunityLoader = 'true';
  const observed = new WeakSet();
  let observer;
  const load = () => {
    if (customElements.get('celvian-community') || document.querySelector('script[data-community-runtime]')) return;
    observer?.disconnect();
    const script = document.createElement('script');
    script.dataset.communityRuntime = 'true';
    script.src = url.href;
    script.async = true;
    // A failed download can be retried by explicit focus, pointer interaction or the editor.
    script.addEventListener('error', () => script.remove(), {once: true});
    document.head.append(script);
  };
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) load();
    }, {rootMargin: '1800px 0px'});
  }
  const scan = (scope = document, force = false) => {
    const nodes = scope.matches?.('celvian-community') ? [scope] : scope.querySelectorAll('celvian-community');
    for (const node of nodes) {
      if (force || !observer || window.Shopify?.designMode) { load(); return; }
      if (!observed.has(node)) { observed.add(node); observer.observe(node); }
    }
  };
  scan();
  document.addEventListener('focusin', event => { if (event.target.closest('celvian-community')) load(); });
  document.addEventListener('pointerdown', event => { if (event.target.closest('celvian-community')) load(); }, {passive: true});
  document.addEventListener('shopify:section:load', event => scan(event.target, true));
  document.addEventListener('shopify:section:unload', event => {
    const nodes = event.target.matches?.('celvian-community') ? [event.target] : event.target.querySelectorAll('celvian-community');
    nodes.forEach(node => observer?.unobserve(node));
  });
})();
